import {useGetter} from '@/composable/useGetter'

export const useRecaptcha = () => {
    const { lang } = useGetter(['lang'])
    const gKey = window.siteKeyGoogleCaptcha
    const scriptSrc = `https://www.google.com/recaptcha/api.js?render=${gKey}&hl=${lang.value}`
    let recaptchaWidgetId;

    const initGRecaptcha = () => {
        if (document.querySelector(`script[src="${scriptSrc}"]`)) return

        const script = document.createElement('script')
        script.async = true
        script.defer = true
        script.src = scriptSrc
        document.head.appendChild(script)
    }

    const renderRecaptcha = (callback) => {
        if (typeof grecaptcha !== 'undefined') {
            const div = document.createElement('div')
            div.classList.add('recaptcha')
            document.body.appendChild(div)

            recaptchaWidgetId = grecaptcha.render(div, {
                sitekey: gKey,
                size: 'invisible',
                callback: (token) => callback(token),
            })

            grecaptcha.execute(recaptchaWidgetId)
        } else {
            console.error('grecaptcha is not defined')
        }
    }

    const getRecaptchaToken = async () => {
        try {
            let token;

            if (recaptchaWidgetId === undefined) {
                await new Promise((res) => {
                    renderRecaptcha(res)
                }).then((resToken)=>{
                    token = resToken;
                });
            } else {
                await grecaptcha.execute(recaptchaWidgetId);
                token = grecaptcha.getResponse(recaptchaWidgetId);
            }

            if(!token) { throw new Error('No valid captcha token received!')}

            return token;

        } catch(e) {
            console.error('Error fetching captcha token: ', e.message);
            throw e;
        }
    }

    return {
        initGRecaptcha,
        getRecaptchaToken
    }
}
